import React, { Component } from "react";
import SeatNav from "./seatsnav";
import Seats from "../seat.svg";
import queryString from "query-string";
import axios from "axios";
import "../seatcss.css";
import { Redirect } from "react-router-dom";

let apiEndPoint =
  "https://us-central1-bkyow-22da6.cloudfunctions.net/app/seats";

class Seat extends Component {
  state = {};
  constructor(props) {
    super(props);
    let moviedata = this.props.location ? this.props.location.state.vl : "";

    let timingdata = this.props.location.state.val;
    let selectedtimeind = this.props.match.params.selid;
    console.log("timing data", timingdata);

    if (moviedata)
      this.state = {
        moviedata,
        timingdata,
        selectedtimeind,
        tickets: 0,
        price: 0,
        arr: [],
      };
  }
  async componentDidMount() {
    let { data: resp } = await axios.get(apiEndPoint);
    console.log(resp);
    if (resp) this.setState({ resp: resp });
  }
  handleTime = (ind) => {
    let { arr, resp, selectedtimeind } = this.state;
    let fnd, upd;
    let newarr = [];
    let arrind =
      selectedtimeind > 2
        ? selectedtimeind > 5
          ? 0
          : selectedtimeind - 3
        : selectedtimeind;
    let { dateid } = this.props.match ? this.props.match.params : "";
    if (arr.length > 0) {
      arr.map((vl) =>
        resp[arrind].seats.find((val) => val.rowName === vl.js.rowName)
          ? (upd = resp[arrind].seats.find(
              (val) => val.rowName === vl.js.rowName
            ))
            ? (fnd = upd.seatList.find((value) => value.seatNo === vl.seat))
              ? (fnd.booked = false)
              : ""
            : ""
          : ""
      );
      console.log("update", fnd);
      console.log("resp", resp[dateid]);
    }
    console.log("newarr", newarr);
    this.setState({
      selectedtimeind: ind,
      resp,
      tickets: 0,
      price: 0,
      arr: newarr,
    });
  };
  handleBack = () => {
    let { region, id } = this.props.match.params;
    let { vl } = this.state;

    console.log("in back", id);
    let path = "/bookMovie/" + region + "/" + id;
    this.props.history.push({
      pathname: path,
      search: "",
    });
  };
  removeSeat = (seat, vl, ind, data) => {
    let { resp, selectedtimeind, tickets, price, arr } = this.state;
    let arrind =
      selectedtimeind > 2
        ? selectedtimeind > 5
          ? 0
          : selectedtimeind - 3
        : selectedtimeind;

    let dt = resp[arrind].seats.find((val) => val.rowName === data.rowName);
    let js = dt ? dt.seatList.find((val) => val.seatNo === vl.seatNo) : "";

    if (js) {
      let jsind = arr.findIndex((vl) => vl.js.seatNo === js.seatNo);
      arr.splice(jsind, 1);
      js.booked = false;
      tickets -= 1;
      price = price - dt.price;
      this.setState({ resp, tickets, price, arr });
    }
  };
  handleSeat = (seat, vl, ind, data) => {
    let { resp, selectedtimeind, tickets, price, arr } = this.state;
    let arrind =
      selectedtimeind > 2
        ? selectedtimeind > 5
          ? 0
          : selectedtimeind - 3
        : selectedtimeind;
    let dateid = this.props.match.params.dateid;

    console.log("value", resp[arrind].seats[ind]);

    let dt = resp[arrind].seats.find((val) => val.rowName === data.rowName);
    console.log(dt);
    let js = dt ? dt.seatList.find((val) => val.seatNo === vl.seatNo) : "";
    console.log(js);

    if (js) {
      js.booked = true;
      arr.push({ js: dt, ind: arrind, seat: vl.seatNo });
      price = price + dt.price;
      tickets += 1;
      this.setState({ resp, tickets, price, arr });
    }
  };
  handleSubmit = async () => {
    let { arr, moviedata, timingdata, price, selectedtimeind } = this.state;
    let ticketarr = arr.map((vl) => vl.js.rowName + vl.seat);
    let { time } = queryString.parse(this.props.location.search);
    let { rid, selid, dateid, region, id } = this.props.match.params;
    console.log("dateid", dateid);
    let js = {
      title: moviedata.title,
      movieHall: timingdata.name,
      tickets: ticketarr,
      amount: price,
      time: timingdata.timings[selectedtimeind].name,
      date: time,
    };

    let { data: data } = await axios.post(
      "https://us-central1-bkyow-22da6.cloudfunctions.net/app/seat",
      js
    );
    if (data) {
      this.props.history.push({
        pathname: "/payment",
        search: "",
        state: {
          index: {
            region: region,
            id: id,
            rid: rid,
            selid: selid,
            dateid: dateid,
          },
          timingdata,
        },
      });
    }
  };
  reclinerarr(arr) {
    let temp = [];
    let data = arr ? [...arr.seats] : "";
    console.log(data);
    for (let i = 0; i < 2; i++) {
      if (data) {
        temp.push(data[i]);
      } else {
        return;
      }
    }
    return temp;
  }
  goldarr(arr) {
    let temp = [];
    let data = arr ? [...arr.seats] : "";
    console.log(data);
    for (let i = 2; i < data.length; i++) {
      if (data) {
        temp.push(data[i]);
      } else {
        return;
      }
    }
    return temp;
  }
  render() {
    let { moviedata, timingdata, selectedtimeind, tickets } = this.state;
    let { time } = queryString.parse(this.props.location.search);
    let arrind =
      selectedtimeind > 2
        ? selectedtimeind > 5
          ? 0
          : selectedtimeind - 3
        : selectedtimeind;
    console.log(tickets);
    let recliner = this.reclinerarr(
      this.state.resp ? this.state.resp[arrind] : ""
    );
    /*  let recliner = this.state.resp
      ? this.state.resp[arrind].seats.filter((vl) => vl.price === 420)
      : "";*/
    let golder = this.goldarr(this.state.resp ? this.state.resp[arrind] : "");

    return (
      <div className="container-fluid">
        <SeatNav
          data={moviedata}
          rowdata={timingdata}
          ticket={tickets}
          onBack={this.handleBack}
          page="Seats"
        ></SeatNav>
        <div className="header bg-light">
          <div className="row text-secondary ml-2">
            <span className="m-1">{time}</span>
            <span className="m-1">
              {timingdata ? timingdata.timings[selectedtimeind].name : ""}
            </span>
          </div>

          {timingdata
            ? timingdata.timings.map((vl, index) =>
                index == selectedtimeind ? (
                  <button
                    className="btn btn-sm m-1 btn-outline-success text-white"
                    style={{ backgroundColor: "#2E8B57" }}
                  >
                    {vl.name}
                  </button>
                ) : (
                  <button
                    className="btn btn-outline-success btn-sm m-1"
                    onClick={() => this.handleTime(index)}
                  >
                    {vl.name}
                  </button>
                )
              )
            : ""}
        </div>
        <div className="row ">
          <div className="col-1 d-sm-none d-md-block"></div>
          <div className="col ">
            <br />
            <span className="text-secondary">RECLINER-Rs 420.00</span>
            <hr></hr>
            {recliner
              ? recliner.map((value, index) => (
                  <div>
                    {value.rowName}
                    {value.seatList.map((vl) =>
                      vl.available === false && vl.booked === false ? (
                        <button
                          className="button btn btn-sm btn-outline-secondary-false mr-1 p-1 "
                          style={{ background: "lightgrey" }}
                        >
                          {vl.seatNo}
                        </button>
                      ) : vl.available === true && vl.booked === true ? (
                        <button
                          className="button btn btn-sm btn-outline-primary-false mr-1 p-1"
                          style={{ background: "#2dc492" }}
                          onClick={() =>
                            this.removeSeat(vl.seatNo, vl, index, value)
                          }
                        >
                          {vl.seatNo}
                        </button>
                      ) : (
                        <button
                          className="button btn btn-sm btn-outline-light-false mr-1 p-1"
                          onClick={() =>
                            this.handleSeat(vl.seatNo, vl, index, value)
                          }
                        >
                          {vl.seatNo}
                        </button>
                      )
                    )}
                    <br />
                  </div>
                ))
              : ""}

            <div>
              <br />
              <span className="text-secondary">GOLD-Rs 250.00</span>
              <hr></hr>
              <div className="row m-2">
                <div className="col-xs-4 col-sm-4 col-4">
                  {golder
                    ? golder.map((vl) => (
                        <div className="row">
                          <span>{vl.rowName}</span>
                          {vl.seatList.map((value, index) =>
                            value.seatNo <= 7 ? (
                              <div style={{ margin: "1px" }}>
                                {value.available === false &&
                                value.booked === false ? (
                                  <button
                                    className="button btn btn-sm btn-outline-secondary-false mr-1 p-1"
                                    style={{ background: "lightgray" }}
                                  >
                                    {value.seatNo}
                                  </button>
                                ) : value.available === true &&
                                  value.booked === true ? (
                                  <button
                                    className="button btn btn-sm btn-outline-primary-false mr-1 p-1"
                                    style={{ background: "#2dc492" }}
                                    onClick={() =>
                                      this.removeSeat(
                                        vl.seatNo,
                                        value,
                                        index,
                                        vl
                                      )
                                    }
                                  >
                                    {value.seatNo}
                                  </button>
                                ) : (
                                  <button
                                    className="button btn btn-sm btn-outline-light-false mr-1 p-1"
                                    onClick={() =>
                                      this.handleSeat(
                                        value.seatNo,
                                        value,
                                        index,
                                        vl
                                      )
                                    }
                                  >
                                    {value.seatNo}
                                  </button>
                                )}
                              </div>
                            ) : (
                              ""
                            )
                          )}
                        </div>
                      ))
                    : ""}
                </div>
                <div className=" col-xs-5 col-sm-5 col-5">
                  {golder
                    ? golder.map((vl) => (
                        <div className="row" sty>
                          {vl.seatList.map((value, index) =>
                            value.seatNo > 7 && value.seatNo < 18 ? (
                              <div style={{ margin: "1px" }}>
                                {value.available === false &&
                                value.booked === false ? (
                                  <button
                                    className="button btn btn-sm btn-outline-secondary-true mr-1 p-1"
                                    style={{ background: "lightgray" }}
                                  >
                                    {value.seatNo}
                                  </button>
                                ) : value.available === true &&
                                  value.booked === true ? (
                                  <button
                                    className="button btn btn-sm btn-outline-primary-false mr-1 p-1"
                                    style={{ background: "#2dc492" }}
                                    onClick={() =>
                                      this.removeSeat(
                                        vl.seatNo,
                                        value,
                                        index,
                                        vl
                                      )
                                    }
                                  >
                                    {value.seatNo}
                                  </button>
                                ) : (
                                  <button
                                    className="button btn btn-sm btn-outline-light-false mr-1 p-1"
                                    onClick={() =>
                                      this.handleSeat(
                                        value.seatNo,
                                        value,
                                        index,
                                        vl
                                      )
                                    }
                                  >
                                    {value.seatNo}
                                  </button>
                                )}
                              </div>
                            ) : (
                              ""
                            )
                          )}
                        </div>
                      ))
                    : ""}
                </div>
                <div className="col-xs-3 col-sm-3 col">
                  {golder
                    ? golder.map((vl) => (
                        <div className="row">
                          {vl.seatList.map((value, index) =>
                            value.seatNo >= 18 ? (
                              <div style={{ margin: "1px" }}>
                                {value.available === false &&
                                value.booked === false ? (
                                  <button
                                    className="button btn btn-sm btn-outline-secondary-false mr-1 p-1"
                                    style={{ background: "lightgrey" }}
                                  >
                                    {value.seatNo}
                                  </button>
                                ) : value.available === true &&
                                  value.booked === true ? (
                                  <button
                                    className="button btn btn-sm btn-outline-primary-false mr-1 p-1"
                                    style={{ background: "#2dc492" }}
                                    onClick={() =>
                                      this.removeSeat(
                                        vl.seatNo,
                                        value,
                                        index,
                                        vl
                                      )
                                    }
                                  >
                                    {value.seatNo}
                                  </button>
                                ) : (
                                  <button
                                    className="button btn btn-sm btn-outline-light-false mr-1 p-1"
                                    onClick={() =>
                                      this.handleSeat(
                                        value.seatNo,
                                        value,
                                        index,
                                        vl
                                      )
                                    }
                                  >
                                    {value.seatNo}
                                  </button>
                                )}
                              </div>
                            ) : (
                              ""
                            )
                          )}
                        </div>
                      ))
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-5 col-5"></div>
          <div className="col">
            <img src={Seats} alt="all eyes"></img>
            <figcaption className="ml-5">All Eyes this way please!</figcaption>
            <div className="row ">
              {this.state.price > 0 ? (
                <button
                  className="btn btn-primary submit fixed-bottom col-3"
                  onClick={() => this.handleSubmit()}
                >
                  Pay Price:{this.state.price}
                </button>
              ) : (
                ""
              )}
            </div>

            <br />
          </div>
        </div>
      </div>
    );
  }
}

export default Seat;
